import { palette } from '@centivo/react-components'
import styled from 'styled-components'

export const ParliPracticeName = styled.span<{ gridColumn?: string }>`
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  text-overflow: ellipsis;
  box-orient: vertical;
  -webkit-box-orient: vertical;
  max-width: 15rem;
  color: ${palette.neutral['grey-icons']};
  font-weight: bold;
  text-transform: uppercase;
  color: ${palette.brand.darkPurple};

  ${({ gridColumn }) => (gridColumn ? `grid-column: ${gridColumn};` : '')}

  ${({ theme }) => {
    switch (theme.template) {
      case 'template-4':
        return {
          fontSize: '0.625rem',
          fontWeight: 500,
        }
      default:
        return {
          fontSize: '0.7rem',
          fontWeight: 'bold',
        }
    }
  }}
`

export const ParliSpecialty = styled.span`
  font-size: 0.875rem;
  grid-row: 3;

  color: ${palette.brand.gray};

  ${({ theme }) => {
    switch (theme.template) {
      case 'template-4':
        return {
          fontWeight: 500,
          marginBottom: '0rem',
        }
      default:
        return {
          fontWeight: 600,
          marginBottom: '0.7rem',
        }
    }
  }}
`
